import React, { Component } from 'react';
import { connect } from 'react-redux';
import SalesPrice from '../containers/salestaxes/SalesPrice';
import FloridaSalesTax from '../containers/salestaxes/FloridaSalesTax';
import CountyDiscretionaryTax from '../containers/salestaxes/CountyDiscretionaryTax';
import SubtotalSalesTax from '../containers/salestaxes/SubtotalSalesTax';
import Credit from '../containers/salestaxes/Credit';
import SalesTaxTotal from '../containers/salestaxes/SalesTaxTotal';

class SalesTaxes extends Component {
  render() {
    return (
      <div className="Box">

        <div className="SalesTax">
          <SalesPrice />
          <FloridaSalesTax />
          <CountyDiscretionaryTax />
          <SubtotalSalesTax />
          <Credit />
          <SalesTaxTotal />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    monthsFromNow: state.registration.monthsFromNow,
  };
};

export default connect(mapStateToProps)(SalesTaxes);



// WEBPACK FOOTER //
// ./src/sections/SalesTaxes.js